import { useEffect, useState } from "react";
import { fetchOfficeMaster, downloadOfficeDataExcel } from "../Api/ViewOfficeMaster";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewOfficeMaster = () => {
  const [offices, setOffices] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadOffices = async () => {
      try {
        const data = await fetchOfficeMaster();
        setOffices(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Office Master Data`);
      }
    };

    loadOffices();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadOfficeDataExcel();
      
      // Check if response contains data
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create a blob from the response
      const url = window.URL.createObjectURL(new Blob([response.data]));
      
      // Create a link element
      const link = document.createElement('a');
      link.href = url;
      
      // Set the download attribute with a filename
      link.setAttribute('download', 'OfficeMasterData.xlsx');
      
      // Append to the body, click and remove
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Office data download started successfully!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Error Downloading Office Data: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <span className="list-title">View Office Master</span>
              <Button className="generate-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || offices.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {offices.length > 0 ? (
              <div className="table-wrapper">
                <div className="table-scroll-container">
                  <Table bordered hover className="data-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Office Code</th>
                        <th>Office Name</th>
                        <th>Office Type</th>
                        <th>Company Code</th>
                        <th>Created At</th>
                        <th>Created By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {offices.map((office, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{office.officeCode}</td>
                          <td>{office.officeName}</td>
                          <td>{office.officeType}</td>
                          <td>{office.companyCode}</td>
                          <td>{moment(office.createdAt).format('L')} at {moment(office.createdAt).format('LTS')}</td>
                          <td>{office.createdBy}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            ) : (
              <p className="no-data">No office data found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewOfficeMaster;